module.exports = __webpack_public_path__ + "img/performance-4.ef25869f.png";